var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "image-svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H122C125.314 0 128 2.68629 128 6V122C128 125.314 125.314 128 122 128H6C2.68629 128 0 125.314 0 122V6Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0323 70.2095C83.5224 69.597 84.4587 69.6116 84.9294 70.2391L97.56 87.08C98.1533 87.8711 97.5889 89 96.6 89H31.7127C30.6709 89 30.124 87.7636 30.8247 86.9928L53.1534 62.4312C53.6143 61.9242 54.4054 61.9054 54.8899 62.3899L73.052 80.5519C73.5577 81.0576 74.3907 81.0115 74.8375 80.453L83.0323 70.2095Z",
    fill: "#7A869A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 49C86.5 54.5228 82.0228 59 76.5 59C70.9771 59 66.5 54.5228 66.5 49C66.5 43.4772 70.9771 39 76.5 39C82.0228 39 86.5 43.4772 86.5 49Z",
    fill: "#7A869A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.8 6C0.8 3.12812 3.12812 0.8 6 0.8H122C124.872 0.8 127.2 3.12812 127.2 6V122C127.2 124.872 124.872 127.2 122 127.2H6C3.12812 127.2 0.8 124.872 0.8 122V6Z",
    stroke: "#EBECF0",
    strokeWidth: 1.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 128H122C125.314 128 128 125.314 128 122V118C128 121.314 125.314 124 122 124H6C2.68629 124 0 121.314 0 118V122C0 125.314 2.68629 128 6 128Z",
    fill: "#EBECF0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.dbf90268c428c10e12761527695a8830.svg";
export { ForwardRef as ReactComponent };